/**
 * @voltxampere/ui — Resistor (Direnç) · IEC zigzag
 *
 * Sprint 10.1 freezes the resistor as the canonical Zenit zigzag —
 * 4 peaks centered between x=6 and x=34 with leads at y=13. ANSI
 * rectangle is *not* shipped; ANSI toggle is post-Sprint 12.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const resistor = {
    id: "resistor",
    nameTr: "Direnç",
    nameEn: "Resistor",
    shortcut: "R",
    category: "passive",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, polarity: "bi" },
        { x: 40, y: 13, polarity: "bi" },
    ],
    defaultLabel: "R",
    defaultValue: "1kΩ",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="6" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<path d="M 6 13 L 10 6 L 14 20 L 18 6 L 22 20 L 26 6 L 30 20 L 34 13 L 40 13" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}" stroke-linejoin="round"/>`,
    ].join(""),
};
//# sourceMappingURL=resistor.js.map